<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import SiteHeader from '@/components/SiteHeader.vue'
import SiteFooter from '@/components/SiteFooter.vue'
import AppToaster from '@/components/AppToaster.vue'

const route = useRoute()
const bare = computed(() => Boolean(route.meta.bare))
</script>

<template>
  <template v-if="bare">
    <RouterView />
  </template>
  <template v-else>
    <SiteHeader />
    <main class="page">
      <RouterView />
    </main>
    <SiteFooter />
  </template>
  <AppToaster />
</template>

<style scoped>
.page {
  max-width: var(--max-w);
  margin: 0 auto;
  padding: 1rem 1.5rem;
}
</style>
